import { render, staticRenderFns } from "./DatosRecibo.vue?vue&type=template&id=5b7a8f0c&scoped=true&"
import script from "./DatosRecibo.vue?vue&type=script&lang=js&"
export * from "./DatosRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a8f0c",
  null
  
)

export default component.exports